import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const useNavigationGuard = (SaveEnable, setSaveEnable, message) => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!SaveEnable) return;

    const handleBeforeUnload = (event) => {
      if(SaveEnable){
      event.preventDefault();
      setSaveEnable(false);
      event.returnValue = message; // This is required for the prompt to appear in some browsers
      }
    };

    const handlePopState = (event) => {
      if (SaveEnable && !window.confirm(message)) {
        event.preventDefault();
        setSaveEnable(false);
        // alert("This One is reponsible for")
        navigate(location.pathname);
      }
    };

    const handleBeforeRouteChange = (event) => {
      if (SaveEnable && !window.confirm(message)) {
        event.preventDefault();
        setSaveEnable(false);
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    const originalPushState = window.history.pushState;
    window.history.pushState = function () {
      const result = originalPushState.apply(this, arguments);
      window.dispatchEvent(new Event('pushstate'));
      return result;
    };

    const originalReplaceState = window.history.replaceState;
    window.history.replaceState = function () {
      const result = originalReplaceState.apply(this, arguments);
      window.dispatchEvent(new Event('replacestate'));
      return result;
    };

    window.addEventListener('pushstate', handleBeforeRouteChange);
    window.addEventListener('replacestate', handleBeforeRouteChange);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('pushstate', handleBeforeRouteChange);
      window.removeEventListener('replacestate', handleBeforeRouteChange);
    };
  }, [SaveEnable, message, navigate, location]);
};

export default useNavigationGuard;
